import type { StatusSeverity } from 'components/_base/StatusChip'

// Red for not collecting: in that state the account produces nothing at all.
export const CODE_STATUS: Record<string, { label: string; severity: StatusSeverity }> = {
  collecting: { label: 'Collecting', severity: 'success' },
  not_collecting: { label: 'Not collecting', severity: 'error' },
  unknown: { label: 'Unknown', severity: 'default' },
}

// `||` and not `??`: an empty string is not nullish, and it was rendering an empty badge.
export const codeStatus = (status?: string) =>
  CODE_STATUS[status || ''] ?? { label: status || 'Unknown', severity: 'default' as const }
